<template>
    <form v-if="form" @submit.prevent="submitForm" @input="onFormChange">
        <p class="mb-5">
            Great! Your job is going to be finished, it's time to review and rate for your freelancer. Your review and rating will
            affect the freelancer's reputation.
        </p>
        <div class="mb-5">
            <label class="block font-bold mb-2">Your Rating</label>
            <user-rating v-model="form.rate" :rating="form.rate" />
        </div>

        <my-textarea v-model="form.review" :rows="5" :error="form.errors.get('review')" name="review" label="Your Review" />
    </form>
</template>

<script>
import Form from '../../forms/form';

export default {
    props: {
        projectSlug: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            form: new Form({
                rate: 0,
                review: null
            })
        };
    },

    methods: {
        submit() {
            let uri = `/api/projects/${this.projectSlug}/finish`;

            return new Promise((resolve, reject) => {
                this.form
                    .post(uri)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        onFormChange(event) {
            this.form.errors.clear(event.target.name);
        }
    }
};
</script>
